var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.8625 9.99849C2.86215 10.1524 2.92068 10.3065 3.03808 10.4239L7.83487 15.2241C8.06911 15.4585 8.44903 15.4586 8.68343 15.2244C8.91783 14.9902 8.91791 14.6103 8.68367 14.3759L4.90734 10.5969H16.2636C16.595 10.5969 16.8636 10.3282 16.8636 9.99689C16.8636 9.66553 16.595 9.39689 16.2636 9.39689H4.91334L8.68367 5.62414C8.91791 5.38975 8.91783 5.00985 8.68343 4.77561C8.44903 4.54137 8.06911 4.54149 7.83489 4.77588L3.07513 9.53865C2.94506 9.64873 2.86249 9.81313 2.86249 9.99689L2.8625 9.99849Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.01e36622b7e644c5898c2b786bd248ce.svg";
export { ForwardRef as ReactComponent };